// material style
import { CardContent, Tooltip, Typography } from "@mui/material";

// material icons
import { Email, Drafts, Delete } from "@mui/icons-material";

// styled components
import {
  StyledMessageCard,
  StyledGridContainer,
  StyledGridItem,
  MessageBox,
  StyledIconTypography,
  DeleteIconMessage,
} from "./MessageCard.style";

export default function MessageCard(props) {
  return (
    <StyledMessageCard onClick={props.click} isSeen={props.item.is_seen}>
      <CardContent>
        <StyledGridContainer container spacing={0}>
          <MessageBox item xs={9}>
            <Typography>{props.index + 1}</Typography>
            <Typography>{props.item.full_name}</Typography>
            <Typography>{props.item.email}</Typography>
            <StyledIconTypography isSeen={props.item.is_seen}>
              {props.item.is_seen ? (
                <Tooltip title="مشاهده شده" placement="top">
                  <Drafts />
                </Tooltip>
              ) : (
                <Tooltip title="مشاهده نشده" placement="top">
                  <Email />
                </Tooltip>
              )}
            </StyledIconTypography>
          </MessageBox>
          <StyledGridItem item xs={3}>
            <Tooltip title="حذف" placement="top">
              <DeleteIconMessage>
                <Delete
                  onClick={(e) => {
                    e.stopPropagation();
                    props.delete();
                  }}
                />
              </DeleteIconMessage>
            </Tooltip>
          </StyledGridItem>
        </StyledGridContainer>
      </CardContent>
    </StyledMessageCard>
  );
}
